// ═══════════════════════════════════════════════════════════════════
//  modules/wiki/WikiContenu.js
//  WikiContenu
// ═══════════════════════════════════════════════════════════════════

import { useEffect, useRef } from "react";

// ═══════════════ Contenu rendu + clic sur les pastilles ═══════════════
export function WikiContenu({ html, onChip }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const clic = (e) => {
      const chip = e.target.closest && e.target.closest(".wiki-chip");
      if (!chip || chip.classList.contains("wiki-chip-mort")) return;
      e.preventDefault();
      onChip && onChip(chip.getAttribute("data-type"), chip.getAttribute("data-id"), chip.textContent.trim());
    };
    el.addEventListener("click", clic);
    return () => el.removeEventListener("click", clic);
  }, [html, onChip]);
  return <div className="wiki-doc" ref={ref} dangerouslySetInnerHTML={{ __html: html || "" }} />;
}
